/**
 * Input Schema of CargaMedlog
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {CargaMedlog} from '@/model/resource/CargaMedlog'
import {CargaCollection} from '@/model/collection/CargaCollection'

/* TODO: review generated schema */
export class InputCargaMedlogSchema extends Schema {
  collectionCarga = new CargaCollection().noPagination()

  readonly name = 'InputCargaMedlog'

  readonly fieldSet: FieldSet<CargaMedlog> = {
    carga: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionCarga.all(),
      },
    }),
    erro: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
  }
}
